import service from '@/utils/request'
// 全部标签类型
export function allbqAPI() {
  return service.post(`config/labellist`,);
}

// 获取电压用电类型

export function getotherlabelAPI() {
  return service.post(`config/otherlabel`,);
}

// 获取行业列表
export function gethangyelistAPI() {
  return service.post(`config/hangyelist`,);
}

// 获取省市区列表
export function getarealistAPI() {
  return service.post(`config/arealist`,);
}
